import { render, staticRenderFns } from "./VsTableHeading.vue?vue&type=template&id=f75edf50&lang=pug&"
import script from "./VsTableHeading.vue?vue&type=script&lang=js&"
export * from "./VsTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./VsTableHeading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f75edf50')) {
      api.createRecord('f75edf50', component.options)
    } else {
      api.reload('f75edf50', component.options)
    }
    module.hot.accept("./VsTableHeading.vue?vue&type=template&id=f75edf50&lang=pug&", function () {
      api.rerender('f75edf50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsTableHeading.vue"
export default component.exports